import { FormikToggleField } from 'components/FormikToggleField/FormikToggleField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface RejectUnauthorizedValues {
  rejectUnauthorized: boolean;
}

interface Props<T extends RejectUnauthorizedValues> {
  formik: FormikProps<T>;
}

export const FormikVendorApiRejectUnauthorizedField = <
  T extends RejectUnauthorizedValues,
>(
  props: Props<T>,
): JSX.Element => {
  const {
    discoverySettings: {
      vendorsApi: { labels: labelsMsg },
    },
  } = useLocale();
  return (
    <FormikToggleField
      className='mb-4'
      formik={props.formik}
      name='rejectUnauthorized'
      label={labelsMsg.rejectUnauthorized}
      labelPosition='right'
      hideStateMessage
    />
  );
};
